(ns frontend.view.reports.custom.alj-2.deals-presented-to-CIC-charts
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))

(defn cic-presented
  [date-state-atom]
  (let [{:keys [start-ts end-ts]} @date-state-atom]
    (->> (alj/all-deals)
         (filter (fn [oppo]
                   (when-let [presented-to-CIC-on (:oppo/date-CIC-presentation oppo)]
                     (and (<= start-ts presented-to-CIC-on)
                          (>= end-ts presented-to-CIC-on)))))
         (remove (fn [oppo]
                   (= (:oppo/status oppo) :oppo.status/on-hold)))
         (doall))))

(defn deals-per-status
  [deals]
  (let [deals-by-status (->> deals
                             (group-by :oppo/status))]
    {:series    [{:name         (loc/tr :oppo/status)
                  :colorByPoint true
                  :data         (->> deals-by-status
                                     (map (fn [[status oppos]]
                                            {:name          (loc/tr status)
                                             :y             (count oppos)
                                             :ticketSizeSum (alj-utils/ticket-size-sum-millions oppos)
                                             :drilldown     (loc/tr status)}))
                                     (vec))}]
     :drilldown {:series (->> deals-by-status
                              (map (fn [[status oppos]]
                                     {:name (loc/tr status)
                                      :id   (loc/tr status)
                                      :data (->> oppos
                                                 (mapcat :oppo/group-business-units)
                                                 (frequencies)
                                                 (map (fn [[bu-id f]]
                                                        [(entity/display-string (session/get-entity bu-id))
                                                         f]))
                                                 (vec))}))
                              (vec))}}))


(defn pie-component
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-cic #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/remove-by :oppo/status :oppo.status/on-hold)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/date-CIC-presentation @date-state-atom :date-cic :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))
            ;deals (cic-presented date-state-atom)
            chart-data (deals-per-status deals)
            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [name y]}]
                                    [name y]))
                             (sort-by first)
                             (doall))
            view-name "Deals presented to IAC"]
        [alj-components/alj-pie-chart-v2
         {:view-name        view-name
          :total-deals      (count deals)
          :total-amount     (alj-utils/ticket-size-sum-billions deals)
          :report-data      export-data
          :chart-data       chart-data
          :date-state-atom  date-state-atom
          :date-range-label "CIC presentation date"}]))))

(defn get-table-data
  [deals]
  (let [rows (->> deals
                  (group-by :oppo/status)
                  (map
                   (fn [[status oppos]]
                     (let [ticket-size-sum (alj-utils/ticket-size-sum-millions oppos)
                           sub-rows (->> oppos
                                         (mapcat (fn [oppo]
                                                   (->> oppo
                                                        :oppo/group-business-units
                                                        (map (fn [bu-id]
                                                               [bu-id oppo])))))
                                         (group-by first)
                                         (map (fn [[bu-id bu-id-oppos]]
                                                (let [bu-entity (session/get-entity bu-id)
                                                      oppos (->> bu-id-oppos
                                                                 (map second)
                                                                 (doall))
                                                      ticket-size-sum (alj-utils/ticket-size-sum-millions oppos)]
                                                  {:business-unit (entity/display-string bu-entity)
                                                   :deal-count    (count oppos)
                                                   :ticket-size   ticket-size-sum})))
                                         (sort-by :ticket-size)
                                         (reverse)
                                         (vec))

                           oppos-no-bu (->> oppos
                                            (remove (fn [oppo]
                                                      (:oppo/group-business-units oppo))))
                           no-bu-ticket-size (alj-utils/ticket-size-sum-millions oppos-no-bu)
                           sub-rows (conj sub-rows
                                          {:business-unit "No business unit"
                                           :deal-count    (count oppos-no-bu)
                                           :ticket-size   no-bu-ticket-size})]
                       {:deal-status status
                        :ticket-size ticket-size-sum
                        :deal-count  (count oppos)
                        :sub-rows    sub-rows})))
                  (sort-by :ticket-size)
                  (reverse)
                  (vec))]
    rows))


(defn table-component
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-cic #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/remove-by :oppo/status :oppo.status/on-hold)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/date-CIC-presentation @date-state-atom :date-cic :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))
            ;deals (cic-presented date-state-atom)
            rows (get-table-data deals)
            view-name "Deals presented to IAC by status - value $M"]
        [alj-components/alj-card
         {:view-name        view-name
          :chart-config     {}
          :total-deals      (count deals)
          :report-data      nil
          :date-state-atom  date-state-atom
          :date-range-label "CIC presentation date"
          :view             [:div
                             [alj-components/table-with-expandable-rows
                              {:headers ["Deal status" "ALJ Ticket Size $M"]
                               :rows    rows}]]}]))))


(def table-2-example-rows
  [{:business-unit "Example unit"
    :portfolio     10
    :active        30
    :passed        43
    :multiple-bu?  false}])



(defn table-2
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{} [:entity.type/oppo]]
                          [:date-cic #{:entity.type/oppo} [:entity.type/oppo]]
                          [:date-portfolio #{} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/remove-by :oppo/status :oppo.status/on-hold)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/date-CIC-presentation @date-state-atom :date-cic :entity.type/oppo)
                       (alj-utils/deals-in-date-range-if-configured :oppo/moved-to-portfolio-on @date-state-atom :date-portfolio :entity.type/oppo))

            ;deals (cic-presented date-state-atom)

            business-units-map (->> (session/non-archived-named-values
                                     :oppo/group-business-units
                                     (alj/alj-report-pipeline-id))
                                    (map (fn [bu]
                                           [(:db/id bu) (:named-value/value bu)]))
                                    (into {}))
            rows (->> deals
                      (group-by (fn [deal]
                                  (let [bus (:oppo/group-business-units deal)
                                        bu (first bus)]
                                    bu)))
                      (mapv
                       (fn [[bu-id bu-deals]]
                         (let [bu-label (if bu-id
                                          (get business-units-map bu-id)
                                          "No business unit")
                               portfolio (->> bu-deals
                                              (cu/filter-by :oppo/status :oppo.status/portfolio)
                                              (count))
                               active (->> bu-deals
                                           (cu/filter-by :oppo/status :oppo.status/ok)
                                           (count))
                               passed (->> bu-deals
                                           (cu/filter-by :oppo/status :oppo.status/passed)
                                           (count))]
                           {:business-unit bu-label
                            :portfolio     portfolio
                            :active        active
                            :passed        passed})))
                      (sort-by :business-unit))

            view-name "Presented to IAC"]
        [alj-components/alj-card
         {:view-name        view-name
          :total-deals      (count deals)
          :report-data      nil
          :date-state-atom  date-state-atom
          :date-range-label "CIC presentation date"
          :view
          [:div
           [:table.alj-report.zap-simple-table
            [:thead
             [:tr
              [:th "Business unit"]
              [:th "Portfolio"]
              [:th "Active"]
              [:th "Passed"]
              [:th "Grand total"]]]
            [:tbody
             (->> rows
                  (map-indexed (fn [row-index row]
                                 (let [{:keys [business-unit portfolio active passed]} row]
                                   ^{:key (str "normal-table-row-" row-index)}
                                   [:tr
                                    [:td business-unit]
                                    [:td portfolio]
                                    [:td active]
                                    [:td passed]
                                    [:td (+ portfolio active passed)]]))))]
            [:tfoot
             (let [total-portfolio (->> rows
                                        (mapv :portfolio)
                                        (apply +))
                   total-active (->> rows
                                     (mapv :active)
                                     (apply +))
                   total-passed (->> rows
                                     (mapv :passed)
                                     (apply +))
                   total-total (->> rows
                                    (mapv (fn [{:keys [portfolio active passed]}]
                                            (+ portfolio active passed)))
                                    (apply +))]
               [:tr.alj-totals-row
                [:td "Grand total"]
                [:td total-portfolio]
                [:td total-active]
                [:td total-passed]
                [:td total-total]])
             [:tr.alj-error-row]
             [:tr.alj-duplicate-row]]]]}]))))
